import { render, staticRenderFns } from "./AnimatedVAlertDialog.vue?vue&type=template&id=9f12f5ae"
import script from "./AnimatedVAlertDialog.vue?vue&type=script&lang=js"
export * from "./AnimatedVAlertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports